// Boton "Solicitar cambio" de la barra superior + flujo completo:
// clic (o Ctrl+Shift+S) -> captura -> modal. Solo se monta si el usuario tiene
// el permiso (ver AppHeader / usePuedeSolicitarCambios).
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { notify } from "../ui/notify";
import { capturarPantalla } from "./capturarPantalla";
import { recolectarInfoTecnica } from "./infoTecnica";
import SolicitarCambioModal from "./SolicitarCambioModal";
import "./solicitarCambio.css";

// `tituloVista`: el mismo titulo que ya muestra la barra superior.
export default function SolicitarCambioButton({ tituloVista }) {
  const { pathname } = useLocation();
  const [sesion, setSesion] = useState(null); // { captura, info }
  const ocupadoRef = useRef(false); // capturando o modal abierto

  const abrir = useCallback(async () => {
    if (ocupadoRef.current) return;
    ocupadoRef.current = true;
    // La info se toma ANTES de capturar, con la pantalla tal como la ve el usuario.
    const info = recolectarInfoTecnica(pathname, tituloVista);
    try {
      const captura = await capturarPantalla();
      setSesion({ captura, info });
    } catch (err) {
      // El backend exige las capturas, asi que sin captura no se abre el modal.
      // eslint-disable-next-line no-console
      console.error("[Solicitar cambio] captura fallida", err);
      ocupadoRef.current = false;
      notify.error("No se pudo tomar la captura de pantalla. Inténtalo de nuevo.");
    }
  }, [pathname, tituloVista]);

  const cerrar = () => {
    ocupadoRef.current = false;
    setSesion(null);
  };

  const enviado = (folio) => {
    cerrar();
    notify.success(`Solicitud ${folio} enviada. Te avisaremos cuando esté en revisión.`);
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && e.shiftKey && !e.altKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        abrir();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [abrir]);

  return (
    <>
      <button
        type="button"
        className="sc-solicitar-btn"
        onClick={abrir}
        title="Solicitar un cambio o reportar un error en esta pantalla"
        aria-label="Solicitar cambio"
      >
        <i className="fa-solid fa-comment-dots" />
        <span>Solicitar cambio</span>
      </button>
      {sesion && (
        <SolicitarCambioModal captura={sesion.captura} info={sesion.info} onClose={cerrar} onEnviado={enviado} />
      )}
    </>
  );
}
